import { render, staticRenderFns } from "./personal_information.vue?vue&type=template&id=405cf9f6&scoped=true"
import script from "./personal_information.vue?vue&type=script&lang=js"
export * from "./personal_information.vue?vue&type=script&lang=js"
import style0 from "./personal_information.vue?vue&type=style&index=0&id=405cf9f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405cf9f6",
  null
  
)

export default component.exports